module.exports = __webpack_public_path__ + "static/media/42.8e2506b4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/newWeatherIcons/42.svg
// module id = 2834
// module chunks = 3